<template>
  <div class="createTopic">
    <page-title :pageTitle="$route.meta.title"></page-title>
    <div class="mainContent">
      <vh-form :model="formData" ref="ruleForm" :rules="rules" label-width="100px">
        <vh-form-item :label="$t('lang.k_109001')" prop="name" class="topicName">
          <vh-input
            v-model="formData.name"
            autocomplete="off"
            type="text"
            :maxlength="100"
            :show-word-limit="true"
            :placeholder="$t('lang.k_109001')"
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_109003')" prop="openWay" class="topicOpenWay">
          <vh-radio-group v-model="formData.openWay">
            <vh-radio :label="0">{{ $t('lang.k_109004') }}</vh-radio>
            <vh-radio :label="1">{{ $t('lang.k_109005') }}</vh-radio>
          </vh-radio-group>
          <div class="tip" v-show="formData.openWay != 1">
            {{ $t('lang.k_109006') }}
          </div>
        </vh-form-item>
        <vh-form-item
          :label="$t('lang.k_109007')"
          prop="timeSet"
          class="topicTimeSet"
          v-if="formData.openWay == 1"
        >
          <vh-radio-group v-model="formData.timeSet">
            <vh-radio :label="0">{{ $t('lang.k_109008') }}</vh-radio>
            <vh-radio :label="1">{{ $t('lang.k_109009') }}</vh-radio>
          </vh-radio-group>
          <div class="tip" v-show="formData.timeSet != 1">
            {{ $t('lang.k_109010') }}
          </div>
          <div class="is-diy" v-show="formData.timeSet == 1">
            {{ $t('lang.k_109011') }}
            <vh-input v-model="formData.beginTime">
              <template slot="append">{{ $t('lang.k_109012') }}</template>
            </vh-input>
            {{ $t('lang.k_109013') }}
            <vh-input v-model="formData.endTime">
              <template slot="append">{{ $t('lang.k_109012') }}</template>
            </vh-input>
            {{ $t('lang.k_109014') }}
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_109015')" prop="bot" class="topicBot">
          <div class="selectedBot" v-if="selectedBot != 0" @click="setBot">
            <div class="box">{{ $t('lang.k_109016', [selectedBot]) }}</div>
            <span class="iconfont-v3 saasicon-reset1"></span>
          </div>
          <div class="selectBot" v-else @click="setBot">
            <span class="iconfont-v3 saasline-plus"></span>
            {{ $t('lang.k_109018') }}
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_109019')" prop="sendWay" class="topicSendWay">
          <vh-radio-group v-model="formData.sendWay">
            <vh-radio :label="0">{{ $t('lang.k_109020') }}</vh-radio>
            <vh-radio :label="1">{{ $t('lang.k_109021') }}</vh-radio>
          </vh-radio-group>
          <div class="tip">
            {{ formData.sendWay != 1 ? $t('lang.k_109022') : $t('lang.k_109023') }}
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_109024')" prop="chatDuring" class="topicChatDuring">
          <vh-input v-model="formData.chatDuring" placeholder="1-300" :maxlength="3">
            <template slot="append">{{ $t('lang.k_109025') }}</template>
          </vh-input>
          <div class="tip">
            {{ $t('lang.k_109026') }}
          </div>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_109027')" prop="giftDuring" class="topicGiftDuring">
          <vh-radio-group v-model="formData.giftDuring">
            <vh-radio :label="0">{{ $t('lang.k_109028') }}</vh-radio>
            <vh-radio :label="1">
              {{ $t('lang.k_109029') }}
              <vh-input v-model="formData.giftDuringNum" :maxlength="3" placeholder="1-300">
                <template slot="append">{{ $t('lang.k_109025') }}</template>
              </vh-input>
            </vh-radio>
          </vh-radio-group>
          <div class="tip">{{ $t('lang.k_109030') }}</div>
        </vh-form-item>
      </vh-form>
      <vh-button type="primary" class="save" round @click="saveTopic" v-preventReClick>
        {{ $t('lang.k_109031') }}
      </vh-button>
      <BotSet ref="botRef" :topic_id="topic_id" @updateBots="updateBots"></BotSet>
    </div>
    <!-- 同步弹出框 -->
    <vh-dialog
      :title="$t('lang.k_109032')"
      :visible.sync="asyncDialog.visible"
      :show-close="false"
      class="zdy-async-dialog"
      width="420px"
    >
      <div class="async__body">
        <div class="async__ctx">
          <p>{{ asyncDialog.question }}</p>
          <vh-checkbox v-model="asyncDialog.sureChecked">{{ asyncDialog.show }}</vh-checkbox>
        </div>
        <div class="async__footer">
          <vh-button type="info" plain size="medium" @click="unSureAsyncHandle" round>
            {{ $t('lang.k_109033') }}
          </vh-button>
          <vh-button type="primary" size="medium" v-preventReClick @click="sureAsyncHandle" round>
            {{ $t('lang.k_109034') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>

    <!-- 开播按钮 -->
    <begin-play
      :webinarId="isInWebinar"
      v-if="$route.query.type != 5 && webinarState != 4 && isInWebinar"
    ></begin-play>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import BotSet from './botSet';
  import { isEmbed, sessionOrLocal } from '@/utils/utils';
  import beginPlay from '@/components/beginBtn';

  export default {
    name: 'ChatEdit',
    components: {
      PageTitle,
      BotSet,
      beginPlay
    },
    data() {
      const validBot = (rule, value, callback) => {
        if (this.selectedBot == 0) {
          callback(new Error(this.$t('lang.k_109035')));
        } else {
          callback();
        }
      };
      const validTimeSet = (rule, value, callback) => {
        if (value == 1) {
          //自定义时间
          if (!this.formData.beginTime || !this.formData.endTime) {
            callback(new Error(this.$t('lang.k_109036')));
          } else if (
            parseInt(this.formData.beginTime + '') > 1000 ||
            parseInt(this.formData.endTime + '') > 1000
          ) {
            callback(new Error(this.$t('lang.k_109037')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      const validGiftDuring = (rule, value, callback) => {
        if (value == 1) {
          if (!this.formData.giftDuringNum) {
            callback(new Error(this.$t('lang.k_109038')));
          } else if (parseInt(this.formData.giftDuringNum + '') > 300) {
            callback(new Error(this.$t('lang.k_109039')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      const validChatDuring = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('lang.k_109040')));
        } else if (parseInt(value + '') > 300) {
          callback(new Error(this.$t('lang.k_109041')));
        } else {
          callback();
        }
      };
      return {
        isEmbed: isEmbed(),
        formData: {
          name: '',
          openWay: 0,
          timeSet: 0,
          beginTime: '5',
          endTime: '5',
          sendWay: 0,
          chatDuring: '5',
          giftDuring: 0,
          giftDuringNum: '10',
          chatbot_number: 0,
          chatbot_list: []
        },
        selectedBot: 0, //已设置的机器人总数
        rules: {
          name: [{ required: true, message: this.$t('lang.k_109042'), trigger: 'blur' }],
          openWay: [{ required: true, trigger: 'blur' }],
          timeSet: [{ required: true, validator: validTimeSet, trigger: 'change' }],
          bot: [{ required: true, validator: validBot, trigger: 'change' }],
          sendWay: [{ required: true, trigger: 'blur' }],
          chatDuring: [{ required: true, validator: validChatDuring, trigger: 'change' }],
          giftDuring: [{ required: true, validator: validGiftDuring, trigger: 'change' }]
        },
        asyncDialog: {
          visible: false,
          question: this.$t('lang.k_109043'),
          show: this.$t('lang.k_109044'),
          sureChecked: true
        },
        webinarState: JSON.parse(sessionOrLocal.get('webinarState')) // 活动状态
      };
    },
    watch: {
      'formData.beginTime'(val) {
        this.formData.beginTime = (val + '').match(/^([1-9][0-9]*)$/)
          ? (val + '').match(/^([1-9][0-9]*)$/)[0]
          : '';
      },
      'formData.endTime'(val) {
        this.formData.endTime = (val + '').match(/^([1-9][0-9]*)$/)
          ? (val + '').match(/^([1-9][0-9]*)$/)[0]
          : '';
      },
      'formData.chatDuring'(val) {
        this.formData.chatDuring = (val + '').match(/^([1-9][0-9]*)$/)
          ? (val + '').match(/^([1-9][0-9]*)$/)[0]
          : '';
      },
      'formData.giftDuringNum'(val) {
        this.formData.giftDuringNum = (val + '').match(/^([1-9][0-9]*)$/)
          ? (val + '').match(/^([1-9][0-9]*)$/)[0]
          : '';
      }
    },
    computed: {
      isInWebinar() {
        return this.$route.query.webinar_id;
      },
      topic_id() {
        return this.$route.params.id;
      },
      source() {
        let path = this.$route.path;
        if (path.indexOf('edit') != -1) {
          //编辑
          return 'edit';
        } else {
          //新增
          return 'add';
        }
      }
    },
    created() {
      if (this.source == 'edit') {
        this.getTopicInfo();
      } else {
        this.getBotList();
      }
    },
    mounted() {},
    methods: {
      saveTopic() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            console.log(this.formData);
            if (this.isInWebinar && this.source == 'add' && !this.isEmbed) {
              this.asyncDialog.visible = true;
              this.asyncDialog.sureChecked = true;
            } else {
              this.sureAsyncHandle();
            }
          }
        });
      },
      unSureAsyncHandle() {
        this.asyncDialog.visible = false;
      },
      sureAsyncHandle() {
        this.asyncDialog.visible = false;

        let params = {
          content_title: this.formData.name,
          activation_mode: this.formData.openWay,
          timed_start_setting: JSON.stringify({
            type: this.formData.timeSet, // 类型，0-跟随直播状态 1-自定义时间
            start_delay_minutes: this.formData.beginTime, // 开播延迟启动分钟数
            duration_minutes: this.formData.endTime // 持续分钟数
          }),
          chatbot_list: JSON.stringify(this.formData.chatbot_list),
          sending_mode: this.formData.sendWay,
          chat_interval: this.formData.chatDuring,
          gift_interval: this.formData.giftDuring == 1 ? this.formData.giftDuringNum : -1
        };

        if (this.isInWebinar) {
          params.webinar_id = this.isInWebinar;
          params.share_to_library = this.asyncDialog.sureChecked ? 1 : 0;
        }
        if (this.source == 'edit') {
          params.topic_id = this.topic_id;
        }

        this.$fetch('saveTopic', params)
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_109045'));
              let path = (this.isEmbed ? '/embed' : '') + '/AI/chat/list';
              if (this.isInWebinar) {
                path = (this.isEmbed ? '/embed' : '') + '/live/AI/chat/list/' + this.isInWebinar;
              }
              this.$router.push(path);
            } else {
              this.$vhMessage({
                message: res.msg || `${this.$t('lang.k_109046')}`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `${this.$t('lang.k_109046')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      async getTopicInfo() {
        let res = await this.$fetch('getTopicInfo', {
          topic_id: this.topic_id
        });
        if (res.code == 200 && res.data) {
          let info = res.data;
          this.formData.name = info.content_title;
          this.formData.openWay = parseInt(info.activation_mode + '');
          this.formData.timeSet = parseInt(info.timed_start_setting.type + '');
          this.formData.beginTime = info.timed_start_setting.start_delay_minutes;
          this.formData.endTime = info.timed_start_setting.duration_minutes;
          this.formData.sendWay = parseInt(info.sending_mode + '');
          if (info.chatbot_number != 0) {
            this.selectedBot = info.chatbot_number;
            this.formData.chatbot_number = info.chatbot_number;
            this.formData.chatbot_list = info.chatbot_list;
          }

          this.formData.chatDuring = info.chat_interval;
          this.formData.giftDuring = info.gift_interval == -1 ? 0 : 1;
          if (this.formData.giftDuring == 1) {
            this.formData.giftDuringNum = info.gift_interval;
          }
          this.refreshList();
        }
        this.$refs.botRef.initTb(this.formData.chatbot_list);
      },
      async getBotList() {
        let res = await this.$fetch('getBotList', {
          topic_id: this.topic_id
        });
        if (res.code == 200 && res.data) {
          let info = res.data;
          this.formData.chatbot_list = info.list;
          this.formData.chatbot_number = info.total;
          this.refreshList();
        }
        this.$refs.botRef.initTb(this.formData.chatbot_list);
      },
      refreshList() {
        for (let index = 0; index < this.formData.chatbot_list.length; index++) {
          if (!this.formData.chatbot_list[index].botId) {
            this.formData.chatbot_list[index].botId =
              'botId' + new Date().getTime() + Math.floor(Math.random() * 1000 + 1);
          }
          this.formData.chatbot_list[index].show = true;
        }
      },
      updateBots(info) {
        // console.log(info);
        this.selectedBot = info.length;
        this.formData.chatbot_list = JSON.parse(JSON.stringify(info));
        this.formData.chatbot_number = info.length;
      },
      setBot() {
        if (this.selectedBot == 0) {
          this.$refs.botRef.open(null);
        } else {
          this.refreshList();
          this.$refs.botRef.open(this.formData.chatbot_list);
        }
      }
    }
  };
</script>

<style lang="less">
  .createTopic {
    .mainContent {
      background-color: #fff;
      padding: 48px;
      .vh-form {
        .vh-input {
          width: 104px;
          .vh-input-group__append {
            padding: 0 10px;
          }
        }
        .vh-input--limit .vh-input__inner,
        .vh-input--limit.vh-input--medium .vh-input__inner,
        .vh-input--limit.vh-input--mini .vh-input__inner,
        .vh-input--limit.vh-input--small .vh-input__inner {
          padding-right: 54px;
        }
        .topicName .vh-input {
          width: 640px;
        }
        .vh-textarea {
          width: 628px;
        }
        .vh-radio-group {
          &.topic_method {
            .vh-radio {
              display: flex;
              align-items: center;
              &:first-child {
                margin-bottom: 10px;
              }
              .vh-radio__label {
                display: flex;
                align-items: center;
                .vh-input {
                  width: 150px;
                  margin: 0 8px;
                }
              }
            }
          }
        }
        input[type='number'] {
          line-height: 1px !important;
        }
        .topicGiftDuring .vh-radio {
          line-height: 40px;
        }
        .topicOpenWay {
          .vh-form-item__content {
            line-height: 36px;
          }
        }
        .topicBot {
          .selectedBot {
            display: flex;
            width: 220px;
            align-items: center;

            .box {
              width: 180px;
              height: 40px;
              border-radius: 40px;
              text-align: center;
              font-size: 14px;
              border: 1px solid #d9d9d9;
              background-color: #f5f5f5;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            span {
              transform: rotateY(180deg);
              display: inline-block;
              margin-left: 8px;
              cursor: pointer;
              color: #3562fa;
            }
          }
          .selectBot {
            width: 153px;
            height: 40px;
            border-radius: 40px;
            text-align: center;
            font-size: 14px;
            border: 1px solid #d9d9d9;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-size: 12px;
            }
          }
        }
        .topicChatDuring {
          .tip {
            margin-top: 4px;
          }
        }
      }
      .tip {
        color: #8c8c8c;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
      }
      .is-diy {
        display: flex;
        align-items: center;
      }

      .save {
        margin-left: 100px;
        width: 152px;
      }
    }
    .zdy-async-dialog .async__footer {
      padding-bottom: 0;
    }
  }
</style>
